window.COROLL = window.COROLL || {};

window.COROLL.init = function() {

	var pages = window.COROLL.pages;
	var currentId = window.COROLL.currentId;
	var currentPage = pages[currentId] || null;
	var rootPages = [];

	// Vygenerujeme si do struktury i odkazy na potomky
	angular.forEach(pages, function(page) {
		if (page.master) {
			if (pages[page.master]) {
				if (!pages[page.master].children) {
					pages[page.master].children = [];
				}
				pages[page.master].children.push(page);
			}
		}
	});

	// Seřadíme potomky a vytáhneme si stránky nejvyšší úrovně
	angular.forEach(pages, function(page) {
		if (!page.children) {
			page.children = [];
		}
		page.children = page.children.sort(function(p1, p2) {
			return p2.priorita - p1.priorita;
		});

		if (page.master == window.COROLL.rootPageId) {
			rootPages.push(page);
		}
	});	

	// Seřadíme stránky nejvyšší úrovně
	rootPages = rootPages.sort(function(p1, p2) {
		return p2.priorita - p1.priorita;
	});


	angular.module('coroll', [])


		.controller('MainController', ['$scope', function($scope) {

			var currentPos = currentPage;

			$scope.columns = [];
			$scope.columnActiveItems = [];

			$scope.currentPage = currentPage;

			$scope.goToPage = function(page, $event) {

				if (page.children.length) {

					currentPos = page;
					buildColumns();

					$event.preventDefault();
					$event.stopPropagation();

				} else {
					// Leaf page - just follow the link
				}

			}

			function buildColumns() {

				$scope.columns = [];
				$scope.columnActiveItems = [];

				var currentPath = [];

				if (currentPos) {
					var p = currentPos;
					currentPath = [];
					while (p) {
						currentPath.push(p);
						p = pages[p.master];
					}
				} else {
					currentPath = [];
				}		

				currentPath = currentPath.reverse();		

				$scope.columns[0] = rootPages;

				angular.forEach(currentPath, function(page) {
					$scope.columns.push(page.children);
					$scope.columnActiveItems.push(page);
				});

			}

			buildColumns();

		}]);

};

window.COROLL.open = function() {
	$('#submenu').addClass('open');
}

window.COROLL.close = function() {
	$('#submenu').removeClass('open');	
}

$(function() {

	$(document).on('keyup',function(evt) {
		if (evt.keyCode == 27) {
			$('#submenu').removeClass('open');
		}
	});

});
